import { rem } from 'polished'
import { css } from 'styled-components'

// The listing width is dragged by the traveller, so its tiles query the listing, not the viewport.

export const LISTING_CONTENT_INSET_DESKTOP = 40

const LISTING_CONTENT_CONTAINER_NAME = 'experience-listing-content'

/** Below this the two even columns are too narrow for a legible image or a ~95-character
 *  description, so the tile stacks instead. */
const LISTING_WIDE_LAYOUT_BREAKPOINT = 640

export const listingWideLayoutQuery = `@container ${LISTING_CONTENT_CONTAINER_NAME} (min-width: ${rem(LISTING_WIDE_LAYOUT_BREAKPOINT)})`

/** Anything rendering a place tile needs this, not just the listing: without a container to
 *  query, the tiles stack at every width. */
export const listingContentContainer = css`
  container: ${LISTING_CONTENT_CONTAINER_NAME} / inline-size;
`

/** Card width the design settles on inside its 1304px frame. */
const LISTING_CARD_WIDTH = 700

/**
 * A ceiling, not a fixed width: at 2:1 an unbounded column gives a very tall image against two
 * lines of text. Includes the inset, because `inline-size` containment measures the content box.
 */
export const LISTING_CONTENT_MAX_WIDTH =
  LISTING_CARD_WIDTH + LISTING_CONTENT_INSET_DESKTOP * 2
